import { noop } from 'lodash-es';

// This file is used to avoid loading react-native-branch that is not compatible on web
export const useDeeplinks = noop;
